import { Heading, Text } from "@chakra-ui/react";

function MainPage() {
  return (
    <section>
      <Heading>דף הבית</Heading>
      <Text fontSize={"lg"}>ברוכים הבאים למשחקים חינוכיים</Text>
    </section>
  );
}

export default MainPage;
